import React, { Component } from 'react';
import Sample from 'repos/Sample.js';
import Colors from 'components/Colors.js';
import AudioUnit from 'engine/audio.js';
import {dragSample} from 'actions/index.js';
import { connect } from "react-redux";

const colors = new Colors();

class PaletteSampleComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sampleId: this.props.sampleId,
            isPlaying: false,
        };

        this.loadSample();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.sampleId !== nextProps.sampleId) {
            console.log('detected a change, so releading!');
            this.setState({sampleId: nextProps.sampleId});
            this.loadSample();
        } else {
            console.log('nothing changed!');
        }

        return true;
    }

    async loadSample() {
        let sample = new Sample(this.props.sampleId);
        sample.slices = this.props.slices;
        await sample.fetchMetadata();
        this.setState({sample: sample});
        await sample.fetchAudio();

        let audioUnit = new AudioUnit();
        audioUnit.setBuffer(sample.audioBuffer);
        this.setState({audioUnit: audioUnit});
    }

    playSound() {
        console.log('play sound called!');
        if (this.state.audioUnit !== undefined) {
            if (this.state.isPlaying) {
                this.state.audioUnit.stopSound();
            } else {
                if (this.props.slices !== undefined &&
                    this.props.slices.length > 0) {
                    this.state.audioUnit.playSound(this.props.slices[0].startTime);
                } else {
                    this.state.audioUnit.playSound(0);
                }
            }
            this.setState({isPlaying: !this.state.isPlaying});
        }
    }

    onDragStart(e) {
        this.props.dragSample(this.state.sample.getJson());
    }

    onDragOver(e) {
    }

    onDrop(e) {
    }

    render() {
        let thumbnail = '';

        if (this.state.sample !== undefined &&
            this.state.sample.getThumbnail() !== undefined) {
            thumbnail = 
                <img className="palette-sample-thumbnail"
                  src={this.state.sample.getThumbnail()}/>;
        } else if (this.state.sample !== undefined &&
                   this.state.sample.getThumbnail() === undefined) {
            let style = {
                backgroundColor: colors.getColor(this.props.i)
            };
            thumbnail =
                <div style={style} className="palette-sample-thumbnail"></div>
        }
        return (
            <div className="palette-sample"
                  onDragStart={(e) => this.onDragStart(e)}
                  onDragOver={(e) => this.onDragOver(e)}
                  onDrop={(e) => []}
                  draggable
              onClick={() => this.playSound()} >
              {this.state.sample !== undefined ? 
                  thumbnail : ''}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dragSample: resolution => dispatch(dragSample(resolution)),
    }
};

export default connect(null, mapDispatchToProps)(PaletteSampleComponent);
